<template>
    <div style="margin-top: 60px;">
        <van-nav-bar title="Administration" />
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-cell-group>
                <van-cell title="CPU占用率" :value="cpuUsage.toFixed(2) + '%'"
                    title-style="text-align:left;" />
                <van-cell title="内存占用率" :value="memoryUsage.toFixed(2) + '%'"
                    title-style="text-align:left;" />
                <van-cell title="磁盘占用率" :value="storageUsage.toFixed(2) + '%'"
                    title-style="text-align:left;" />
            </van-cell-group>
            <van-cell-group>
                <van-cell title="工会总人数" :value="totalMember"
                    title-style="text-align:left;" />
                <van-cell title="已绑定人数" :value="bindedMember"
                    title-style="text-align:left;" />
                <van-cell title="绑定比率" :value="bindRate.toFixed(2) + '%'"
                    title-style="text-align:left;" />
            </van-cell-group>
            <van-cell-group>
                <van-cell title="白天健身预定人数" :value="bookedDay"
                    title-style="text-align:left;" />
                <van-cell title="白天健身签到人数" :value="checkinDay"
                    title-style="text-align:left;" />
                <van-cell title="白天签到比率" :value="dayCheckinRate.toFixed(2) + '%'"
                    title-style="text-align:left;" />
            </van-cell-group>
            <van-cell-group>
                <van-cell title="晚上健身预定人数" :value="bookedNight"
                    title-style="text-align:left;" />
                <van-cell title="晚上健身签到人数" :value="checkinNight"
                    title-style="text-align:left;" />
                <van-cell title="晚上签到比率" :value="nightCheckinRate.toFixed(2) + '%'"
                    title-style="text-align:left;" />
            </van-cell-group>
        </van-pull-refresh>
    </div>
</template>
<script>
import axios from 'axios';

import { NavBar } from 'vant';
import { Field, CellGroup, PullRefresh, Notify } from 'vant';

export default {
    name: 'Admin',
    data () {
        return {
            cpuUsage: 0.0,
            memoryUsage: 0.0,
            storageUsage: 0.0,
            totalMember: 0,
            bindedMember: 0,
            bindRate: 0.0,
            bookedDay: 0,
            bookedNight: 0,
            checkinDay: 0,
            checkinNight: 0,
            dayCheckinRate: 0,
            nightCheckinRate: 0,
            isLoading: false
        }
    },
    mounted() {
        this.onRefresh();
    },
    methods: {
        onRefresh() {
            var vm = this;
            //console.log("aaa");
            axios.get('/api/statistics')
                .then((res) => {
                    console.log(res.data, '这个是获取调用扫描返回的参数?');
                    vm.cpuUsage = res.data["cpuUsage"];
                    vm.memoryUsage = res.data["memoryUsage"];
                    vm.storageUsage = res.data["storageUsage"];
                    vm.totalMember = res.data["total"];
                    vm.bindedMember = res.data["binded"];
                    vm.bindRate = 100.0 * vm.bindedMember / vm.totalMember;
                    vm.bookedDay = res.data["bookedDay"];
                    vm.bookedNight = res.data["bookedNight"];
                    vm.checkinDay = res.data["checkinDay"];
                    vm.checkinNight = res.data["checkinNight"];
                    if (vm.checkinDay == 0) {
                        vm.dayCheckinRate = 0.0;
                    } else {
                        vm.dayCheckinRate = 100.0 * vm.checkinDay / vm.bookedDay;
                    }
                    if (vm.checkinNight == 0) {
                        vm.nightCheckinRate = 0.0;
                    } else {
                        vm.nightCheckinRate = 100.0 * vm.checkinNight / vm.bookedNight;
                    }
                    var d = new Date();
                    Notify({
                        type: 'success',
                        message: 'Updated at ' + d.toLocaleString(),
                        duration: 0
                    });
                    vm.isLoading = false;
                }).catch((error) => {
                    alert("无法获取基本操作权限!");
                    vm.isLoading = false;
                });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Admin.vue